<template>
    <nav class="categories" v-if="categories && categories.length !== 0">
        <ul>
            <li
                v-for="item in categories"
                :key="item.id"
                :class="{ current: item.slug === $route.params.slug }"
            >
                <Link
                    :post_link="item.link"
                    v-html="item.name"
                    :id="`${item.name}-page`"
                ></Link>
            </li>
        </ul>
    </nav>
</template>

<script>
import Link from "@/components/ui/Link.vue";

export default {
    name: "categories",

    props: {
        categories: {
            default: [],
            type: Array
        },
        id: ""
    },

    components: {
        Link
    }
};
</script>

<style lang="scss">
.categories {
    margin: var(--padding-50) 0;
    position: sticky;
    top: 0;
    z-index: 999;
    background: var(--white);

    ul {
        display: flex;
        padding: 0 calc(var(--padding-50) + var(--padding-25));

        li {
            box-sizing: border-box;
            color: var(--white);
            padding: var(--padding-50) var(--padding-25);
            // width: 25%;
            flex: 1 1 auto;

            a {
                padding: calc(var(--padding-50) - 0.1rem) var(--padding-50)
                    var(--padding-50);
                display: block;
                text-align: center;
                line-height: 1;
                font-size: calc(var(--large-size) - 0.1rem);
                font-weight: bold;
                background: var(--black);
                color: var(--white);
            }

            a:hover {
                background: var(--white);
                color: var(--black);
            }
            &.current a {
                background: var(--white);
                color: var(--black);
            }
        }
    }
}

@media only screen and (max-width: 767px) {
    .categories {
        margin: var(--padding-50) 0 var(--padding);

        ul {
            display: block;
            padding: 0 calc(var(--padding-50) + var(--padding-25));

            li {
                padding: var(--padding-25);
                a {
                    padding: calc(var(--padding-50) - 0.1rem) var(--padding-50)
                        var(--padding-50);
                    text-align: left;
                    font-size: var(--title-size);
                    width: max-content;
                    width: -webkit-max-content;
                }
            }
        }
    }
}
</style>
